import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as services from "../services/services";
import loginIllustration from "../images/dog.jpg";
import logo from "../images/itaam-company-2.png";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const token = params.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || password.length < 8) {
      toast.error("รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร");
      return;
    }

    // Confirm before submit
    if (!window.confirm("คุณแน่ใจจะเปลี่ยนรหัสผ่านบัญชีนี้หรือไม่?")) {
      return;
    }

    try {
      await services.resetPasswordWithEmail({
        token,
        newPassword: password,
      });

      toast.success("เปลี่ยนรหัสผ่านสำเร็จ");
      navigate("/auth/login");
    } catch (err) {
      const status = err?.response?.status;
      if (status === 400 || status === 401) {
        toast.error("Token หมดอายุหรือไม่ถูกต้อง กรุณาขอลิงก์ใหม่อีกครั้ง");
      } else if (status === 500) {
        toast.error("เซิร์ฟเวอร์ขัดข้อง กรุณาลองใหม่ภายหลัง");
      } else {
        toast.error("เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      }
    }
  };

  return (
    <div className="flex min-h-screen">
      <Toaster />

      {/* ซ้าย */}
      <div
        className="hidden md:flex w-[40%] bg-cover bg-center"
        style={{ backgroundImage: `url(${loginIllustration})` }}
      />

      {/* ขวา */}
      <div className="flex w-[60%] items-center justify-center bg-white">
        <form onSubmit={handleSubmit} className="w-full max-w-md px-8 py-10">
          <div className="flex justify-center mb-6">
            <img src={logo} className="w-32" />
          </div>

          <h2 className="text-2xl font-bold text-center mb-6">
            ตั้งรหัสผ่านใหม่
          </h2>

          <div className="relative mt-1">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="รหัสผ่านใหม่"
              value={password}
              onChange={(e) => {
                const v = e.target.value;
                setPassword(v);
                if (v && v.length < 8) setError("รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร");
                else setError("");
              }}
              className="w-full px-3 py-2 pr-11 border rounded-md focus:ring-2 focus:ring-indigo-500"
            />
            <button
              type="button"
              aria-label={showPassword ? "ซ่อนรหัสผ่าน" : "แสดงรหัสผ่าน"}
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-gray-500 hover:text-gray-700"
            >
              {showPassword ? (
                <VisibilityOff fontSize="small" />
              ) : (
                <Visibility fontSize="small" />
              )}
            </button>
          </div>
          {error && <p className="text-red-600 text-sm mt-2">{error}</p>}

          <button
            type="submit"
            className="w-full mt-4 bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-md"
          >
            ยืนยัน
          </button>

          <p className="text-center text-sm mt-6">
            <Link to="/auth/login" className="text-indigo-500">
              กลับไปเข้าสู่ระบบ
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
